import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import CompassionateCareForEveryTail from "./sections/CompassionateCareForEveryTail";
import OurMedicalExpertise from "./sections/OurMedicalExpertise";
import TheHappyPawsPromise from "./sections/TheHappyPawsPromise";
import WhyFamiliesTrustUs from "./sections/WhyFamiliesTrustUs";
import OurHappyPatients from "./sections/OurHappyPatients";
import ReadyToVisit from "./sections/ReadyToVisit";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <CompassionateCareForEveryTail />
      <OurMedicalExpertise />
      <TheHappyPawsPromise />
      <WhyFamiliesTrustUs />
      <OurHappyPatients />
      <ReadyToVisit />
      <Footer />
    </div>;
}